import { ReactNode } from 'react';

import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { BottomSheet, BottomSheetFooter, Button, VSpacing } from '@hh.ru/magritte-ui';

import HeaderNav from 'src/components/Header/HeaderNav';

const TrlKeys = {
    closeButton: 'career-platform.components.mobile-nav.close',
};

interface Props {
    isOpen: boolean;
    onClose: () => void;
    headerComponent?: ReactNode;
}

const HeaderMobileNav: TranslatedComponent<Props> = ({ trls, isOpen, headerComponent = null, onClose }) => (
    <BottomSheet
        visible={isOpen}
        onClose={onClose}
        footer={
            <BottomSheetFooter>
                <Button size="medium" mode="secondary" style="accent" stretched onClick={onClose}>
                    {trls[TrlKeys.closeButton]}
                </Button>
            </BottomSheetFooter>
        }
    >
        {headerComponent}
        <VSpacing default={24} />
        <HeaderNav mobile />
        <VSpacing default={24} />
    </BottomSheet>
);

export default translation(HeaderMobileNav);
